<script>
    let deviceList;
    const dateOptions = {year: 'numeric', month: 'long', day: 'numeric', hour: "numeric", minute: "numeric"};
    import { dataset_dev } from 'svelte/internal';
    import Login from './Login.svelte';
    import devices from './stores/DeviceStore.js';
    import environment from './stores/EnvironmentStore.js';
    export let app;
    let showSidebar;
    let keywords = "";
    let selectedTab = 'devices';
    let searchInput;
    const hideProperties = ["appId", "meta", "_id", "createdAt", "updatedAt", "deviceEui", "__v", "receivedAt"];
    const displayProperties = [
      {systemName: "receivedAt", displayName: "received at" , unit: ""},
      {systemName: "accMotion", displayName: "acceleration motion" , unit: ""},
      {systemName: "humidity", displayName: "humidity" , unit: "%"},
      {systemName: "digital", displayName: "magnet" , unit: ""},
      {systemName: "pulseAbs", displayName: "pulse absolute" , unit: ""},
      {systemName: "receivedAt", displayName: "received at" , unit: ""},
      {systemName: "vdd", displayName: "voltage" , unit: "mV"},
      {systemName: "temperature", displayName: "temp" , unit: "°C"},
      {systemName: "x", displayName: "x" , unit: ""},
      {systemName: "z", displayName: "z" , unit: ""},
      {systemName: "y", displayName: "y" , unit: ""},
      {systemName: "motion", displayName: "motion" , unit: ""},
      {systemName: "light", displayName: "light" , unit: "lux"},
      {systemName: "waterleak", displayName: "waterleak" , unit: ""},
    ];

    let test;
    let fieldabc = "temperature";
    const testabc = async (device) => {
      return await getEnvironmentData(device); 
    }

    // These templates are listed under "Filters" tab and defines what we let the users filter device list on.
    const filterTemplates = [
      {displayName: 'Temperature above 25 °C', operator: '>', systemName: 'temperature', value: 25},
      {displayName: 'Temperature below 18 °C', operator: '<', systemName: 'temperature', value: 18},
      {displayName: 'Magnet Lock Open', operator: '<', systemName: 'digital', value: 1},
    ];

    const filterTemplateClickHandler = async(filterTemplate) => {
      // test first with updating the device store and see if it gets filtered
      // find all env data with appid, systemName, operator and value
      // get devices wich match an id in the env collection and matches the app id

      // from device end point:
      // if(searchFields.includes("deviceEui")) searchFieldsParams.push({deviceEui: searchFieldOptions});

      // or just refresh device list and get environment data with the filter applied. temp gt 20
      await devices.getAll(app._id, 'port', "tags"); 
    }

    const getDeviceList = async(appId, keywords) => {
      deviceList = await devices.getAllImmutable(appId, keywords);
    }

    const getEnvironmentData = async (device) => {
      return await environment.getLatestOne(device.appId, device.deviceEui);
    }
    
    const deviceClickHandler = async (device) => {
        await devices.getAll(app._id, device.deviceEui, "deviceEui"); 
        showSidebar = false;
    }

    const deviceTagClickHandler = async (tag) => {
        await devices.getAll(app._id, tag, "tags"); 
        showSidebar = false;
    }

    const updateDeviceList = async (appId, keywords) => { await getDeviceList(appId, keywords); }
    $: { updateDeviceList(app._id, keywords);}

    const clearSearch = async () => { 
    keywords = '';
    searchInput.value = '';
    await updateDeviceList(app._id, keywords);
    await devices.getAll(app._id)
    showSidebar = false;
  }
</script>

<Login/>

<section class="section">
    <h1 class="title">{app.title}</h1>
    <div class="columns is-multiline">
        <div class="column mt-1 is-hidden-tablet">
          <nav class="panel">
            <div class="panel-block clickable" on:click={() => showSidebar = !showSidebar} on:keydown={() => {}}>
              <p class="is-size-7 has-text-right"> 
                <span class="icon">
                  <i class="fas fa-bars" aria-hidden="true"></i>
                </span>
                Menu
              </p>      
            </div>
          </nav>  
        </div>
        <div class="column is-narrow-desktop mt-1" class:is-hidden-mobile={!showSidebar}>
            <nav class="panel">
                <div class="panel-block">
                  <p class="control has-icons-left">
                    <input class="input" type="text" placeholder="Find" bind:this={searchInput} on:change={e => keywords = e.target.value}>
                    <span class="icon is-left">
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </span>
                  </p>
                </div>
                <p class="panel-tabs">
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <a class:is-active={selectedTab === 'devices'} on:click={() => {selectedTab = 'devices'}} on:keydown={() => {}}>Devices</a>
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <a class:is-active={selectedTab === 'filters'} on:click={() => {selectedTab = 'filters'}} on:keydown={() => {}}>Filters</a>
                </p>
                {#if selectedTab === 'devices'}
                {#await getDeviceList(app._id, keywords)} 
                  <!-- <p>Fetching devices</p> -->
                  {:then}
                    {#each deviceList as device }
                      <!-- svelte-ignore a11y-missing-attribute -->
                      <a class="panel-block" on:click={() => deviceClickHandler(device)} on:keydown={() => {}}>
                        <span class="panel-icon has-text-info">
                          <i class="fas fa-house-signal" aria-hidden="true"></i>
                        </span>
                        {device.title}
                      </a>
                      {#if device.tags.length > 0}
                        <div class="panel-block">
                          <div class="tags">
                            {#each device.tags as tag}
                              <span class="tag is-light" on:click={async () => await deviceTagClickHandler(tag)} on:keydown={() => {}}>{tag}</span>
                            {/each}
                          </div>
                        </div>
                      {/if}
                    {/each}
                  {:catch error}
                    <p>{error}</p>
               {/await}
              {/if}



              <!-- svelte-ignore a11y-missing-attribute -->
              {#if selectedTab === 'filters'}
                {#each filterTemplates.filter(el => el.displayName.toLowerCase().includes(keywords)) as filterTemplate}
                  <a class="panel-block" on:click={() => filterTemplateClickHandler('appIDHere', filterTemplate)} on:keydown={() => {}}>
                    <span class="panel-icon has-text-info">
                      <i class="fas fa-house-signal" aria-hidden="true"></i>
                    </span>
                    {filterTemplate.displayName}
                  </a>
                {/each}
             {/if}



                <div class="panel-block">
                  <button class="button is-info is-outlined is-fullwidth" on:click={clearSearch}>
                    Reset all filters
                  </button>
                </div>
              </nav>
        </div>
        <div class="column mt-1 is-size-7">
        <div class="columns is-multiline">
        {#await devices.getAll(app._id)} 
        <!-- <p>Fetching devices</p> -->
        {:then}
          {#each $devices as device }
            {#await testabc(device)}
              <!-- loading data -->
            {:then data}
              {#each Object.entries(data) as [key, value]}
                {#if key == "temperature" && value == "12.9"}
                  {value}
                {/if}
          {/each}  
        {/await}

                <div class="column is-full">
                    <div class="card is-1">
                        <header class="card-header">
                            <p class="card-header-title">
                            {device.title}
                            </p>
                            <button class="card-header-icon" aria-label="more options">
                            <span class="icon has-text-info">
                                <i class="fas fa-house-signal" aria-hidden="true"></i>
                            </span>
                            </button>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                {#if device.tags.length > 0}
                                <div class="tags">
                                {#each device.tags as tag}
                                    <span class="tag is-light" on:click={async () => await deviceTagClickHandler(tag)} on:keydown={() => {}}>{tag}</span>
                                {/each}
                                </div>
                                {/if}
                                {#await getEnvironmentData(device)}
                                  <!-- loading data -->
                                {:then data} 
                                  <div class="columns is-multiline">
                                  {#each Object.entries(data) as [key, value]}
                                    {#if !hideProperties.includes(key)}
                                        <div class="column is-half">
                                          <div class="columns is-multiline separator mr-4">
                                            <div class="column is-half">{(displayProperties.find(item => item.systemName === key))?.displayName || key}</div>
                                            <div class="column is-half has-text-right">
                                              <strong>
                                                {value} {(displayProperties.find(item => item.systemName === key))?.unit}
                                              </strong>
                                            </div>
                                          </div>
                                        </div>
                                    {/if}
                                  {/each}  
                                  </div>
                                  <p class="mt-5">
                                    {#if data.receivedAt}
                                    Last updated {new Date(data.receivedAt).toLocaleString("no-NO", dateOptions)}
                                    {/if}
                                  </p>  
                                {:catch}
                                  <p>Could not load data.</p>
                                {/await}
                            </div>
                        </div>
                        <footer class="card-footer">
                            <!-- svelte-ignore a11y-missing-attribute -->
                            <!-- <div class="card-footer-item is-narrow is-size-7"> </div> -->
                            <!-- svelte-ignore a11y-missing-attribute -->
                            <!-- <div class="card-footer-item is-narrow is-size-7"></div> -->
                        </footer>
                    </div>    
                </div>
            {/each}
            {:catch error}
                <p>{error}</p>
            {/await}
        </div>
      </div>
    </div>
</section>


<style>
    section {
      background-color: #FAFAFA;
    }
    .tag:hover {
        cursor: pointer;
    }
    .clickable:hover {
        cursor: pointer;
    }
    .separator {
      border-bottom: 1px solid #F4F4F4;
    }
    .card-header-icon {
        cursor: default;
    }
</style>